/* unplugin-vue-components disabled */import script from "./NoteList.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteList.vue?vue&type=script&setup=true&lang=js"

import "./NoteList.vue?vue&type=style&index=0&id=0f95a609&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f95a609"]])

export default __exports__